export default [
  {
    path: '/order/list',
    name: 'order-list',
    component: () => import('@/views/orders/orders-list/OrdersList.vue'),
   
  },

  {
    path: '/order/view/:id',
    name: 'order-view',
    component: () => import('@/views/orders/invoice/invoice-preview/InvoicePreview.vue'),
    
  },
  {
    path: '/order/edit/:id/:isEdit',
    name: 'order-edit',
    component: () => import('@/views/orders/invoice/invoice-edit/InvoiceEdit.vue'),
   
  },
  {
    path: '/order/add',
    name: 'order-add',
    component: () => import('@/views/orders/invoice/invoice-add/InvoiceAdd.vue'),
  },
]
